import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectors, actionCreators, sliceKeys } from '../../../model';
import { useRelatedAddresses } from '../../../api/relatedAddresses';
import FetchDataWrapper from '../../../../../components/FetchDataWrapper';
import Btn, { btnTypes } from '../../../../../components/btn';
import ColListWrapper from '../../../shared/ui/ColListWrapper';
import { useParentRoom, useSetParentRoom } from '../ParentRoomProvider';
import {
  RelatedRoomsProvider,
  useHasRelatedRooms,
  useRelatedRoomsActions,
} from './provider';
import List from './List';
import BaseRoomItem from '../../../shared/ui/BaseRoomItem';
import styles from './index.module.scss';

const { selectCurrentId: selectCompanyId } = selectors[sliceKeys.companies];
const { selectHouses } = selectors[sliceKeys.houses];
const { relationAdded } = actionCreators[sliceKeys.houses];

const RelatedRoomsSelection = () => {
  return (
    <ColListWrapper scrollable>
      <RelatedRoomsProvider>
        <Content />
      </RelatedRoomsProvider>
    </ColListWrapper>
  );
};

export default RelatedRoomsSelection;

function Content() {
  const parentRoom = useParentRoom();

  return (
    <>
      <BaseRoomItem room={parentRoom}>
        <RelatedRoomsBlock parentRoom={parentRoom} />
      </BaseRoomItem>
      <Actions />
    </>
  );
}

function RelatedRoomsBlock({ parentRoom }) {
  const serviceCompanyId = useSelector(selectCompanyId);
  const houses = useSelector(selectHouses);

  const { data, isFetching, refetch } = useRelatedAddresses({
    params: {
      serviceCompanyId,
      addressId: parentRoom.id,
      houseIds: houses.map((house) => house.id),
    },
  });

  return (
    <FetchDataWrapper
      data={data}
      isFetching={isFetching}
      refetch={refetch}
      errMsg={`Не удалось получить связанные помещения для № ${parentRoom.flat}`}
    >
      <List rooms={data} parentHouseId={parentRoom.houseId} />
    </FetchDataWrapper>
  );
}

function Actions() {
  const setParent = useSetParentRoom();
  const { reset } = useRelatedRoomsActions();

  const handleCancel = () => {
    reset();
    setParent();
  };

  return (
    <li className={styles.actions}>
      <Btn type={btnTypes.primaryInvert} onClick={handleCancel}>
        Отменить
      </Btn>
      <Bind reset={handleCancel} />
    </li>
  );
}

function Bind({ reset }) {
  const dispatch = useDispatch();

  const { getState } = useRelatedRoomsActions();

  const hasRelatedRooms = useHasRelatedRooms();
  const parentRoom = useParentRoom();

  const handleClick = () => {
    dispatch(relationAdded(parentRoom, getState().relatedRooms));
    reset();
  };

  return (
    <Btn
      type={btnTypes.primary}
      onClick={handleClick}
      disabled={!hasRelatedRooms}
    >
      Добавить связку
    </Btn>
  );
}
